import { Button, Card, CardContent, CardHeader, Dialog, DialogContent, DialogTitle, Grid, IconButton, Typography } from "@material-ui/core";
import { Close, QueryBuilderOutlined } from "@material-ui/icons";
import { Row } from "bnb-ui/dist";
import React, { useEffect, useState } from "react";
import VersaoApi from "../../models/versao-api";
import { consultarVersaoCredenciada } from "../../provider/credenciada-service";
import { consultarVersaoLaudoAvaliacao } from "../../provider/laudo-avaliacao-service";
import { consultarVersaoLaudo } from "../../provider/laudo-service";
import { consultarVersaoGateway } from "../../provider/versao-service";
import { useSelector } from "react-redux";
import Usuario from "../../models/usuario";

type CardHeaderProps = {
	titulo?: string;
	versao?: string;
	build?: string;
	offline?: boolean;
};

const VersaoSistema: React.FC<CardHeaderProps> = (props: CardHeaderProps): JSX.Element => {
	return (
		<div>
			<Card>
				<CardHeader title={props.titulo} style={{ background: "#a6193c", color: "white", minWidth: "320px" }} titleTypographyProps={{ variant: "subtitle2" }} />
				<CardContent style={{ background: "#fafafa" }}>
					<Typography variant="body2" color="textPrimary" component="p">
						Versão: {props.versao}
					</Typography>
					<Typography variant="body2" color="textPrimary" component="p">
						Builded: {props.build}
					</Typography>
					{props.offline && (
						<Typography variant="body2" color="textSecondary" component="p">
							Offline
						</Typography>
					)}
				</CardContent>
			</Card>
		</div>
	);
};

type ModalVersaoProps = {
	open: boolean;
};
const ModalVersao: React.FC<ModalVersaoProps> = (props: ModalVersaoProps): JSX.Element => {
	const [open, setOpen] = useState(props.open);
	const [versaoGateway, setVersaoGateway] = useState<VersaoApi>(new VersaoApi());
	const [versaoCredenciada, setVersaoCredenciada] = useState<VersaoApi>(new VersaoApi());
	const [versaoLaudo, setVersaoLaudo] = useState<VersaoApi>(new VersaoApi());
	const [versaoLaudoAvaliacao, setVersaoLaudoAvaliacao] = useState<VersaoApi>(new VersaoApi());
	const usuarioLogado: Usuario = useSelector((state: any) => state.usuarioLogadoState.usuarioLogado);

	const handleClickOpen = (): void => {
		setOpen(true);
	};
	const handleClose = (): void => {
		setOpen(false);
	};

	const getVersaoGateway = async (): Promise<void> => {
		try {
			const response = await consultarVersaoGateway();
			if (response.data) {
				setVersaoGateway(response.data);
			}
		} catch {
			versaoGateway.offline = true;
		}
	};

	const getVersaoCredenciada = async (): Promise<void> => {
		try {
			const response = await consultarVersaoCredenciada();
			if (response.data) {
				setVersaoCredenciada(response.data);
			}
		} catch {
			versaoCredenciada.offline = true;
		}
	};

	const getVersaoLaudo = async (): Promise<void> => {
		try {
			const response = await consultarVersaoLaudo();
			if (response.data) {
				setVersaoLaudo(response.data);
			}
		} catch {
			versaoLaudo.offline = true;
		}
	};

	const getVersaoLaudoAvaliacao = async (): Promise<void> => {
		try {
			const response = await consultarVersaoLaudoAvaliacao();
			if (response.data) {
				setVersaoLaudoAvaliacao(response.data);
			}
		} catch {
			versaoLaudoAvaliacao.offline = true;
		}
	};

	useEffect(() => {
		if (open) {
			getVersaoGateway();
			getVersaoCredenciada();
			getVersaoLaudo();
			getVersaoLaudoAvaliacao();
		}
	}, [open]);

	return (
		<div className="versaoSistema">
			<Grid container direction="row" spacing={1} alignItems="center">
				<Button
					variant="outlined"
					color="primary"
					onClick={handleClickOpen}
					style={{ paddingTop: "15px", paddingLeft: "25px", fontSize: "14px", textTransform: "none" }}
					// paddingLeft: "82px"
					startIcon={<QueryBuilderOutlined />}
				>
					Versão
				</Button>

				<Dialog onClose={handleClose} aria-labelledby="titleVersao" open={open} disableAutoFocus>
					<DialogTitle
						disableTypography
						style={{
							display: "flex",
							justifyContent: "space-between",
							alignItems: "center",
						}}
					>
						<Typography variant="subtitle1">Sistemas</Typography>
						<IconButton aria-label="close" onClick={handleClose}>
							<Close />
						</IconButton>
					</DialogTitle>
					<DialogContent dividers>
						<Row>
							<Grid item md={12} xs={12}>
								Nome Usuário: {usuarioLogado.nome}, Matricula: {usuarioLogado.matricula}, Tecnico Externo: {usuarioLogado.isTecnicoExterno ? "Sim" : "Não"}
							</Grid>
							<Grid item md={12} xs={12}>
								Email: {usuarioLogado.email || "(não preenchido)"}
							</Grid>
						</Row>
						<Row>
							<Grid item md={6} xs={12}>
								<VersaoSistema titulo="S610-CREDENCIADA-SERVICO" versao={versaoCredenciada.versao} build={versaoCredenciada.build} offline={versaoCredenciada.offline} />
							</Grid>
							<Grid item md={6} xs={12}>
								<VersaoSistema titulo="S610-GATEWAY-SERVICO" versao={versaoGateway.versao} build={versaoGateway.build} offline={versaoGateway.offline} />
							</Grid>
						</Row>

						<Row>
							<Grid item md={6} xs={12}>
								<VersaoSistema titulo="S610-LAUDO-SERVICO" versao={versaoLaudo.versao} build={versaoLaudo.build} offline={versaoLaudo.offline} />
							</Grid>
							<Grid item md={6} xs={12}>
								<VersaoSistema
									titulo="S610-LAUDO-AVALIACAO-SERVICO"
									versao={versaoLaudoAvaliacao.versao}
									build={versaoLaudoAvaliacao.build}
									offline={versaoLaudoAvaliacao.offline}
								/>
							</Grid>
						</Row>
					</DialogContent>
				</Dialog>
			</Grid>
		</div>
	);
};

export default ModalVersao;
